import { TasksTopLevelFilterKey } from '@omnea-app/tasks/tasksFrontendClient'

export const taskQueryKeys = {
  all: ['tasks'] as const,
  list: (filter: TasksTopLevelFilterKey | null) => ['tasks', 'list', filter] as const,
  listCount: (filter: TasksTopLevelFilterKey) => ['tasks', 'list', filter, 'count'] as const,
  mineForRequest: (requestId: string) => ['tasks', 'request', requestId, 'mine'] as const,
  allForRequest: (requestId: string) => ['tasks', 'request', requestId, 'all'] as const,
}
